import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { trashApi } from 'entities/trash/api/trashApi';

export type FinallyDeleteSectionModalControllerActions = {
  afterSectionFinallyDelete?: (id: string) => void;
};

export default observer(function FinallyDeleteSectionModalController({
  id,
  afterSectionFinallyDelete,
  handleClose,
}: {
  id: string;
} & FinallyDeleteSectionModalControllerActions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.finallyDelete.sectionMain')}
        secondText={t('warnings.finallyDelete.sectionSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await trashApi.deleteSection(id);
            afterSectionFinallyDelete && afterSectionFinallyDelete(id);
            handleClose();
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
            handleClose();
          }
        }}
      ></WarningModal>
    </>
  );
});
